import { gql } from "@stadium/services/apollo-client";

export const FETCH_SWAG_FLOW_USER_CONFIG = gql`
  query getUserConfig {
    user {
      id
      automatedCatalogBannerDismissed
      automatedCatalogFooterCartGuideTourViewed
      automatedCatalogLogoDragTooltipViewed
      isDesigner
    }
  }
`;
